const routes = {
    home: '/',
    personal: '/personal',
    radio: '/radio',
    zingchart: '/Chart',
    chartsweek: '/chart-week',
    following: '/following',
    newmusic: '/newmusic',
    category: '/category',
    top100: '/top100',
    mv: '/mv',
};

export default routes;
